// Third party libs
import { FocusTrap } from 'focus-trap-vue';
import * as Sentry from '@sentry/vue';
import Notifications from '@kyvg/vue3-notification';
import Toggle from 'vue-js-toggle-button';
import FloatingVue, { Dropdown } from 'floating-vue';
import 'floating-vue/dist/style.css';

// Our modal plugin (Vue 3 compatible replacement for vue-js-modal)
import vmodal from '@/plugins/modal';
import { createApp } from 'vue';
import VueCookies from 'vue-cookies';

// Our stuff
import Analytics from '@/plugins/telemetry/index';
import App from '@components/app';
import Apptimize from '@/plugins/apptimize/index';
import Authorization from '@/plugins/authorization/index';
import disableable from '@directives/disableable';
import EventBus from '@/plugins/eventBus/index';
import routerSetup from '@/router';
import scrollable from '@directives/scrollable';
import Sheets from '@/plugins/sheets';
import storeSetup from '@/store';
import GAuth from '@/plugins/google-auth';
import { setAppInstance } from '@/app-instance';

// Log version info in development
if (process.env.NODE_ENV === 'development') {
  console.log(
    '%c🚀 HLT Web App',
    'font-weight: bold; font-size: 14px;',
    `\n   Node: ${process.env.BUILD_NODE_VERSION}`,
    `\n   Vue:  ${process.env.BUILD_VUE_VERSION}`,
  );
}

// Create the Vue app instance
const app = createApp(App);

// Store app reference for Vuex modules to access globalProperties
setAppInstance(app);

// Error handler
app.config.errorHandler = function(e, vm, info) {
  console.log(e);
};

// Sentry integration
if (['production', 'staging'].includes(process.env.WEB_ENV)) {
  Sentry.init({
    app,
    dsn: `${process.env.SENTRY_DSN}`,
    environment: process.env.WEB_ENV,
    release: `${process.env.SOURCE_VERSION}`,
  });
}

// Google Auth options
const gauthOption = {
  clientId: '808656977083-4aavq9am6hiu0ujmr2tn2vu4mt9sg9v5.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account',
};

// Setup store and router (router will be updated in Step 5.5)
const store = storeSetup();
const router = routerSetup(app, store);

// Register plugins
app.use(router);
app.use(store);
app.use(GAuth, gauthOption);
app.use(VueCookies);
app.use(Notifications);
app.use(Toggle);
app.use(Analytics);
app.use(Authorization);
app.use(Apptimize);
app.use(EventBus);
app.use(Sheets);
app.use(vmodal);
app.use(FloatingVue);

// Register directives
app.directive('disableable', disableable);
app.directive('scrollable', scrollable);

// Register global components
app.component('FocusTrap', FocusTrap);
app.component('VDropdown', Dropdown);

// Mount the app when DOM is ready
window.onload = function() {
  app.mount('#app');
};
